/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IReferral } from 'app/shared/model/referral.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { ITumorBoardOccurrence } from 'app/shared/model/tumor-board-occurrence.model';

export interface ITumorBoardReferral {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  referral?: IReferral | null;
  patient?: IGlucoUser | null;
  occurrence?: ITumorBoardOccurrence | null;
}

export const defaultValue: Readonly<ITumorBoardReferral> = {
  active: false,
};
